import classNames from 'classnames';

export default function Skeleton({
  className,
  theme = 'sand'
}: {
  className?: string;
  theme?: 'gray' | 'brown' | 'graphite' | 'sand';
}) {
  return (
    <div
      className={classNames(
        'bg-[length:200%_100%] animate-skeleton',
        className,
        {
          'bg-skeleton-gray': theme === 'gray',
          'bg-skeleton-brown': theme === 'brown',
          'bg-skeleton-graphite': theme === 'graphite',
          'bg-skeleton-sand': theme === 'sand'
        }
      )}
    />
  );
}
